import { DashboardModule, Link } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import { generateUrls } from '@hooks/useOrderBundle'
import useOrderBundles from '@hooks/useOrderBundles'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import BundleListItem from './BundleListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Order Bundle Title or ID',
    },
  ]
}

interface BundlesProps {
  providerPriceListId: number,
}

const Bundles = (props: BundlesProps) => {
  const { providerPriceListId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const { orderBundlesIndexUrl } = generateUrls()

  const orderBundlesPayload = useOrderBundles({
    filters: {
      ...pageFilters,
      provider_price_list_id: providerPriceListId,
    },
    performHttpRequests: !!providerPriceListId,
    requestOptions: {
      include_order_bundle_price_list_ids: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredOrderBundles,
    filteredOrderBundlesCount,
    hasFilteredOrderBundles,
    loading,
  } = orderBundlesPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Bundles"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && hasFilteredOrderBundles && (
        <DashboardModule.ScrollableSection>
          {filteredOrderBundles.map(bundle => (
            <BundleListItem
              bundle={bundle}
              key={bundle.id}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredOrderBundles && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Bundles Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            You can assign the Price List to a bundle <Link href={orderBundlesIndexUrl}>here</Link>.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredOrderBundlesCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default Bundles
